import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

interface PaymentProfileActionDropdownProps {
  profileId: string;
  status: "ACTIVE" | "INACTIVE" | "FAILED";
  handleArchive: () => void;
  handleActivate: () => void;
  handleDelete: () => void;
  isArchiving: boolean;
  isActivating: boolean;
  isDeleting: boolean;
}

export function PaymentProfileActionDropdown(
  props: PaymentProfileActionDropdownProps
) {
  const {
    profileId,
    status,
    handleArchive,
    handleActivate,
    handleDelete,
    isArchiving,
    isActivating,
    isDeleting,
  } = props;
  const { t } = useTranslation();

  const isLoading = isArchiving || isActivating || isDeleting;

  return (
    <DropdownMenu
      triggerButton={
        <GhostIconButton
          testID={`payment-profile-actions-${profileId}`}
          size="small"
          icon="more_horiz"
          aria-label={t("Expand menu")}
          isDisabled={isLoading}
        />
      }
      onItemAction={(key) => {
        switch (key) {
          case "archive":
            handleArchive();
            break;
          case "activate":
            handleActivate();
            break;
          case "delete":
            handleDelete();
            break;
        }
      }}
    >
      {status === "ACTIVE" && (
        <MenuItem
          id="archive"
          testID={`archive-payment-profile-${profileId}`}
          textColor="text-danger"
        >
          <Trans>Archive profile</Trans>
        </MenuItem>
      )}
      {status === "INACTIVE" && (
        <>
          <MenuItem
            id="activate"
            testID={`activate-payment-profile-${profileId}`}
          >
            <Trans>Activate profile</Trans>
          </MenuItem>
          <MenuItem
            id="delete"
            testID={`delete-payment-profile-${profileId}`}
            textColor="text-danger"
          >
            <Trans>Delete profile</Trans>
          </MenuItem>
        </>
      )}
      {status === "FAILED" && (
        <MenuItem
          id="delete"
          testID={`delete-payment-profile-${profileId}`}
          textColor="text-danger"
        >
          <Trans>Delete profile</Trans>
        </MenuItem>
      )}
    </DropdownMenu>
  );
}
